<template>
  <!-- 弹窗 -->
  <a-modal
    :cancel-text="a_modal.cancelText"
    :ok-text="a_modal.okText"
    :title="a_modal.title"
    v-model:open="a_modal.visible"
    @ok="a_modal.handleOk"
  >
    {{ a_modal.content }}
  </a-modal>
  
  <div class="locale">
    <div class="header" @click="backToHome">
      <LeftOutlined />
      返回
    </div>

    <div class="image">
      <a-tabs>
        <a-tab-pane>
          <template #tab>
            <span>
              <FileImageTwoTone style="font-size: 18px;" />
              现场照片
            </span>
          </template>

          <div>
            <a-upload
              v-model:file-list="a_upload.fileList"
              action="https://api.gdpinganxing.com/api/upload/image"
              :data="upload_data"
              list-type="picture-card"
              :multiple="true"
              @preview="preview"
            >
              <div v-if="a_upload.fileList.length < 8">
                <plus-outlined />
                <div style="margin-top: 8px">+ 现场照片</div>
              </div>
            </a-upload>
            <a-modal :open="previewVisible" title="预览" :footer="null" @cancel="cancel">
              <img style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
          <div class="btn">
            <a-button type="primary" @click="submit">提交</a-button>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import { FileImageTwoTone, LeftOutlined } from '@ant-design/icons-vue'
const a_modal = ref({
  cancelText: '取消',
  content: '',
  handleOk: null,
  okText: '确定',
  title: '',
  visible: false
})
const route = useRoute()
const router = useRouter()
const uuid = ref(null)
const upload_data = ref({
  uuid: null,
  type: 'locale'
})
const previewImage = ref('');
const previewVisible = ref(false);
const a_upload = ref({
  fileList: []
})
const backToHome = () => {
  router.push(`/${uuid.value}`)
}
const preview = (file) => {
  previewImage.value = file.thumbUrl;
  previewVisible.value = true;
}
const cancel = () => {
  previewVisible.value = false;
}
const submit = () => {
  a_modal.value.title = 'Tips:'
  a_modal.value.content = '提交成功！感谢您的配合！'
  a_modal.value.visible = true
  a_modal.value.handleOk = () => {
  a_modal.value.visible = false
    router.push(`/${uuid.value}`)
  }
}

onMounted(() => {
  upload_data.value.uuid = uuid.value = route.params.id
})
</script>
  
<style scoped>
.image {
  margin-top: 58px;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  z-index: 1;
}
.btn {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
.btn > input {
  margin-right: 16px;
}
</style>